<template>
    <div>
        <div class="nano">
            <div class="character-wrap nano-content" v-infinite-scroll="load"
                 v-if="value.content&&value.content.length">
                <div class="character-item" v-for="(item, index) in value.content" :key="index">
                    <div class="item-head">
                        <div class="item-head-left">
                            <img :src="item.space.photo" alt="" class="rounded-circle img-thumbnail cursor"
                                 @click="change('gotoPeople', item)">
                            <div class="head-name overflow-hidden-1">
              <span class="f14 font-weight-bold title cursor"
                    @click="change('gotoPeople', item)"
                    :title="item.space.name"><p class="overflow-hidden-1">{{item.space.name}}</p></span>
                                <span class="tags" :title="item.space.tags">{{item.space.tags}}</span>
                            </div>
                        </div>
                        <div>
              <span @click="change('gotoAsk', item)" class="ask-text cursor"
                    data-toggle="modal" data-target="#myModal"><i class="fa fa-comments-o icon-m"></i>Consulting Service</span>
                            <span @click="change('gotoFocus', item)" class="cursor">
                <i :class="{ 'startrue': item.space.collect }" class="fa fa-star-o"></i>
              {{item.space.collect ? 'Followed' : 'Follow'}}</span>
                        </div>
                    </div>
                    <div class="item-bottom overflow-hidden-2">
                        <span class="bottom-text">Article：</span>
                        <span v-for="(article, articleIndex) in item.content" :key="articleIndex"
                              class="bottom-content cursor"
                              v-if="item.content && item.content.length"
                              @click="change('gotoArticle', article)">
                                {{article.title||'No published articles'}}
                        </span>
                        <span v-if="!item.content || !item.content.length" class="bottom-content cursor"
                              @click="change('gotoArticle', article)">No
                            published
                            articles</span>
                    </div>
                </div>
                <p class="text-center p-2 w-100" v-if="value.spaceLoadShow">
                    <i
                            class="fa fa-spinner fa-pulse fa-2x mt-3"></i></p>
                <!--        <p class="text-center p-2 w-100" v-if="value.spaceEndShow">没有更多数据了...</p>-->
            </div>
            <p class="text-center p-2 w-100" v-else>
                <i
                        class="fa fa-spinner fa-pulse fa-2x mt-3"></i></p>
        </div>
        <!--    <p v-if="noMore">没有更多了</p>-->
    </div>
</template>

<script>
export default {
  name: 'characterColumn',
  props: {
    value: {
      type: Object
    }
  },
  methods: {
    change (type, value) {
      this.$emit('change', type, value)
    },
    load (val) {
      if (this.value.page === this.value.pageCount) {
        this.value.page = this.value.pageCount
        this.value.spaceEndShow = true
      } else {
        this.value.page += 1
        this.$emit('jumpList', this.value.page)
      }
    }
  }
}
</script>

<style scoped lang="less">
    // @media screen and (min-width: 768px) and (max-width: 1400px) {
    //     .item-head {
    //         flex-direction: column;

    //         /deep/ .item-head-left {
    //             .head-name {
    //                 span:nth-of-type(1) {
    //                     white-space: initial;
    //                 }
    //             }
    //         }

    //         > div:nth-of-type(2) {
    //             display: flex;
    //             flex-wrap: wrap;
    //         }
    //     }

    // }

    .nano {
        margin-top: 18px;
    }

    .character-wrap {
        width: 100%;
        height: 100%;

        /*.fa {*/
        /*  margin-right: 2px;*/
        /*}*/

        .icon-m {
            margin-right: 2px;
        }

        .ask-text {
            padding-right: 12px;
        }

        .character-item {
            width: 100%;
            min-height: 132px;
            background: #F9F9F9;
            padding: 16px 18px;

            .item-head {
                // display: flex;
                // justify-content: space-between;
                /deep/ .item-head-left {
                    .head-name {
                        span:nth-of-type(1) {
                            white-space: initial;
                        }
                    }
                }

                > div:nth-of-type(2) {
                    display: flex;
                    flex-wrap: wrap;
                }

                .item-head-left {
                    display: flex;
                    flex: 1;

                    .head-name {
                        display: flex;
                        flex-direction: column;
                        padding-left: 18px;
                        flex: 1;

                        .title {
                            color: #343A40;
                            width: 100%;
                            height: auto;
                        }

                        .tags {
                            font-size: 12px;
                            padding-top: 10px;
                            color: #6C757D;
                        }
                    }

                    img {
                        width: 52px;
                        height: 52px;
                    }
                }
            }
        }

        .character-item + .character-item {
            margin-top: 18px;
        }

        .item-bottom {
            font-size: 12px;
            margin-top: 10px;

            span {
                display: inline-block;
            }

            .bottom-text {
                color: #9EA6B5;
            }

            .bottom-content {
                color: #6C757D;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3; /*超出3行部分显示省略号，去掉该属性 显示全部*/
                -webkit-box-orient: vertical;
            }
        }
    }

    .overflow-hidden-1 {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .cursor {
        cursor: pointer;
    }
</style>
